import { useContext } from 'react';
import { ModalStateContext } from './context.es.js';

function useModal() {
  const context = useContext(ModalStateContext);
  if (!context) {
    throw new Error("useModal must be inside a ModalStateContext with a state value");
  }
  return context;
}

export { useModal };
